import { Component, css, html, LitElement } from '@rxdi/lit-html';
import { ReactRevealAnimation } from '@shared/animations/react.css';

import { CheckMarkIcon } from './check-mark';

const style = css`
  .features {
    padding-top: 100px;
    padding-bottom: 100px;

    color: #03193f;
    display: flex;
    flex-direction: row;
  }
  * {
    box-sizing: border-box;
  }
  .features ul {
    margin-left: auto;
    margin-bottom: 0;
    list-style: none;
  }
  .features .text {
    max-width: 450px;
    width: 100%;
    margin-right: 0px;
  }
  .features .text h2 {
    margin-top: 15px;
    margin-bottom: 25px;
    letter-spacing: 0.26px;
    font-size: 36px;
    line-height: 41px;
  }
  @media (max-width: 550px) {
    .features {
      flex-direction: column;
    }
  }
  ${ReactRevealAnimation}
  .features .text .point {
    font-size: 22px;
    font-weight: 500;
    line-height: 28px;
    font-weight: 400;
  }
  .features ul li {
    color: #677693;
    font-size: 18px;
    letter-spacing: 0.14px;
    line-height: 28px;
    position: relative;
  }
  .content {
    max-width: calc(1110px + 2rem);
    width: 100%;
    padding-left: 1rem;
    padding-right: 1rem;
    margin: 0 auto;
  }
  .features ul li {
    margin-bottom: 10px;
  }
  ul {
    margin: 0px;
  }
  .features ul li .check {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    content: ' ';
    position: absolute;
    left: -30px;
    top: 6px;
  }
`;
/**
 * @customElement second-panel
 */
@Component({
  selector: 'second-panel',
  style,
  template(this: SecondPanel) {
    return html`
      <div class="content features">
        <div class="text">
          <div class="point">Remove Inconsistencies</div>
          <h2>Improve Your Team's Workflow</h2>
          <p>
            Graphql Cloud provides a consistent, declarative environment for everyone working on the same project.
            <b>Spend less time configuring, and more time coding.</b>
          </p>
        </div>
        <ul>
          <li>
            <div class="check">${CheckMarkIcon}</div>
            <div>
              <b>No more "It works on my machine"</b>, everyone working on the same project is working in the same
              environment.
            </div>
          </li>
          <li>
            <div class="check">${CheckMarkIcon}</div>
            <div><b>Stop duplicating effort</b>, source-control and collaborate on the environment.</div>
          </li>
          <li>
            <div class="check">${CheckMarkIcon}</div>
            <div><b>Instant set-up</b>, open pre-configured environments straight from GitHub or GitLab.</div>
          </li>
          <li>
            <div class="check">${CheckMarkIcon}</div>
            <div><b>Feel production in your dev env</b>, deploy with one click</div>
          </li>
        </ul>
      </div>
    `;
  },
})
export class SecondPanel extends LitElement {}
